import { type IconProps } from '../iconProps';

export const WallClock: React.FC<IconProps> = ({
  fill = '#79716B',
}: IconProps) => {
  return (
    <svg
      width='24'
      height='20'
      viewBox='0 0 16 22
      '
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.3 15.0135L14.7 13.6135L11 9.91348V5.31348H9V10.7135L13.3 15.0135ZM10 20.3135C8.61667 20.3135 7.31667 20.051 6.1 19.526C4.88333 19.001 3.825 18.2885 2.925 17.3885C2.025 16.4885 1.3125 15.4301 0.7875 14.2135C0.2625 12.9968 0 11.6968 0 10.3135C0 8.93014 0.2625 7.63014 0.7875 6.41348C1.3125 5.19681 2.025 4.13848 2.925 3.23848C3.825 2.33848 4.88333 1.62598 6.1 1.10098C7.31667 0.575977 8.61667 0.313477 10 0.313477C11.3833 0.313477 12.6833 0.575977 13.9 1.10098C15.1167 1.62598 16.175 2.33848 17.075 3.23848C17.975 4.13848 18.6875 5.19681 19.2125 6.41348C19.7375 7.63014 20 8.93014 20 10.3135C20 11.6968 19.7375 12.9968 19.2125 14.2135C18.6875 15.4301 17.975 16.4885 17.075 17.3885C16.175 18.2885 15.1167 19.001 13.9 19.526C12.6833 20.051 11.3833 20.3135 10 20.3135ZM10 18.3135C12.2167 18.3135 14.1042 17.5343 15.6625 15.976C17.2208 14.4176 18 12.5301 18 10.3135C18 8.09681 17.2208 6.20931 15.6625 4.65098C14.1042 3.09264 12.2167 2.31348 10 2.31348C7.78333 2.31348 5.89583 3.09264 4.3375 4.65098C2.77917 6.20931 2 8.09681 2 10.3135C2 12.5301 2.77917 14.4176 4.3375 15.976C5.89583 17.5343 7.78333 18.3135 10 18.3135Z'
        fill={fill}
      />
    </svg>
  );
};
